import { render, staticRenderFns } from "./Trayectos.vue?vue&type=template&id=1d8970ce&"
import script from "./Trayectos.vue?vue&type=script&lang=js&"
export * from "./Trayectos.vue?vue&type=script&lang=js&"
import style0 from "./Trayectos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports